module.exports = {"id":"207664","name":"Carlos Bacca","rating":"82","photo":"./data/images/photos/1/207664.png","club":{"name":"Villarreal CF","logo":"./data/images/clubs/VillarrealCF.png"},"positions":["BU"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/CarlosBacca0.json
// module id = 712
// module chunks = 0